export const selectIsLoggedIn = state =>
    state.member && state.member.isLoggedIn;
